import { useState } from 'react';

import {
  IconButton,
  Theme,
  WithStyles,
  createStyles,
  styled,
  withStyles,
} from '@material-ui/core';
import { TabPanelProps } from '@material-ui/lab';

import { RiExternalLinkLine as OpenInNewIcon } from '@remixicon/react';
import classNames from 'classnames';

import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from '@backstage/ui';

import { JsonDiff, JsonSideBySide } from '../JsonDiff';
import ActivityItemTabPanel from './ActivityItemTabPanel';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    json: {
      overflow: 'auto',
    },
    dialog: {
      backgroundColor: theme.palette.action.hover,
    },
  });

export interface JsonPanelProps
  extends Omit<TabPanelProps, 'value' | 'classes'>,
    WithStyles<typeof styles> {
  oldValue: object | undefined;
  newValue: object | undefined;
}

const OpenDialogButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
}));

const ActivityItemJsonPanel = ({
  classes,
  oldValue,
  newValue,
  className,
  ...rest
}: JsonPanelProps) => {
  const [open, setOpen] = useState(false);

  return (
    <ActivityItemTabPanel
      value="json"
      {...rest}
      className={classNames(className, classes.json)}
    >
      <OpenDialogButton size="small" onClick={() => setOpen(true)}>
        <OpenInNewIcon size={20} />
      </OpenDialogButton>
      <JsonDiff
        className={classes.json}
        oldValue={oldValue}
        newValue={newValue}
      />

      <Dialog
        isOpen={open}
        onOpenChange={setOpen}
        width="clamp(400px, 90vw, 1200px)"
        style={{ maxHeight: '80vh' }}
      >
        <DialogHeader>Change</DialogHeader>
        <DialogBody>
          <JsonSideBySide oldValue={oldValue} newValue={newValue} />
        </DialogBody>
        <DialogFooter>
          {oldValue && (
            <Button
              variant="secondary"
              onClick={() =>
                navigator.clipboard.writeText(JSON.stringify(oldValue, null, 2))
              }
            >
              Copy old value to clipboard
            </Button>
          )}
          {newValue && (
            <Button
              variant="secondary"
              onClick={() =>
                navigator.clipboard.writeText(JSON.stringify(newValue, null, 2))
              }
            >
              Copy new value to clipboard
            </Button>
          )}
        </DialogFooter>
      </Dialog>
    </ActivityItemTabPanel>
  );
};

export default withStyles(styles)(ActivityItemJsonPanel);
